import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Apollo } from 'apollo-angular';
import { ContratistaService } from 'src/app/services/contratista.service';
import { EmailService } from 'src/app/services/email.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { LoginService } from 'src/app/services/login.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';
import { valueFromAST } from 'graphql';
import { FacturacionService } from 'src/app/services/facturacion.service';
import {PRECIO_UNITARIO_BASICA, IVA, PRECIO_UNITARIO_BASICA_IVA, PRECIO_UNITARIO_AMPLIADA, PRECIO_UNITARIO_AMPLIADA_IVA} from './../../../../constants/constants';

@Component({
  selector: 'app-alta-contratista',
  templateUrl: './alta-contratista.component.html',
  styleUrls: ['./alta-contratista.component.scss']
})
export class AltaContratistaComponent implements OnInit {
  datosContratista:any =[]
  userlog:any
  nombreComercial:any
  iva: number
  precioBasica: number
  precioBasicaIva: number
  precioAmpliada: number
  precioAmpliadaIva: number

  constructor(private formBuilder: FormBuilder, 
    private apollo: Apollo, 
    private contratistaService: ContratistaService, 
    public dialog: MatDialog, 
    private emailService:EmailService, 
    private loginService: LoginService, 
    public confirmacionService: ConfirmacionService,
    private facturaService:FacturacionService,
    private usuarioService: UsuariosService) {
    this.userlog = loginService.getUserData()
    this.nombreComercial = this.userlog.cliente.nombreComercial
    this.iva = IVA;
    this.precioBasica = PRECIO_UNITARIO_BASICA;
    this.precioBasicaIva = PRECIO_UNITARIO_BASICA_IVA;
    this.precioAmpliada = PRECIO_UNITARIO_AMPLIADA;
    this.precioAmpliadaIva = PRECIO_UNITARIO_AMPLIADA_IVA;
   }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(){
    this.datosContratista = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      cif: ['',[Validators.required]],
      nombreContacto: ['', [Validators.required]],
      mailContacto: ['', [Validators.required,Validators.email]],
      numeroCentros: ['', [Validators.required]],
      policy: ['', [Validators.required]],
    });
  }
  save(event:Event){
    event.preventDefault();
    const value = this.datosContratista.value;
    this.getContratistasCif(value)
  }

  addContratista(){
    let password = this.generatePassword();
    this.apollo.mutate<any>({
      mutation: this.contratistaService.addContratista(),
      variables: {
        "input": {
          "data": {
            "nombreComercial": this.datosContratista.value.nombre,
            "cif": this.datosContratista.value.cif,
            "contactoResponsable": {
              "nombre":this.datosContratista.value.nombreContacto,
              "mail": this.datosContratista.value.mailContacto,
            },
            "numeroInvitacion": this.datosContratista.value.numeroCentros,
            "firstTime": false
          }
        }
      }
    }).subscribe(({data}) => {
      const templateContratista = `
        <!DOCTYPE html>
        <html>
        <head>
        <title></title>
        </head>

        <body>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/logo_xtensa_4908df85aa.png' style="width:200px; height:126px; display:block;
        margin:auto;">
        <div style="width:500px; margin:auto">
        <h1 style="color: #1F775A; font-weight:bolder; text-align:center">Ha recibido una invitación de ${this.nombreComercial}</h1>
        
        <p>Estimado ${this.datosContratista.value.mailContacto}</p>
        <p>Su cliente le invita a utilizar XTENSA con el objetivo de verificar que realiza una correcta gestión de los residuos.</p>
        <p>Usted tiene cedida la imagen de su cliente en sus instalaciones, el cual quiere estar seguro de que en dichos centros se realiza una correcta gestión de los residuos, por lo que le va a solicitar, a través de XTENSA, la documentación que lo justifica (alta de centro productor, autorizaciones de gestores, contratos de tratamiento, memoria anual, etc.).</p>
        <p>A continuación, deberá  acceder al Área Virtual, rellenar los datos
        básicos y realizar el pago de la licencia. Una vez confirmado el
        pago, podrá disfrutar del uso de  XTENSA accediendo al
        Área Virtual con las mismas claves que aparecen en este correo.</p>
        <a href="www.xtensa.es"><img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/AV_96b6ea682a.png' style="width:100px; height:63px; display:block;
        margin:auto;"></a>
        <p>Su usuario es: ${this.datosContratista.value.mailContacto}</p>
        <p>Su contraseña es: ${password}</p>
        </div>
        <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
        margin:70px auto;">
        </body>
        </html>`;

          this.emailService.send(
            this.datosContratista.value.mailContacto,
            'Invitación Xtensa',
            templateContratista
          );
      console.log('OK')
     
      this.addUsuarioContratista(data.createContratista.contratista.contactoResponsable.mail, password, data.createContratista.contratista.id)

      if (this.userlog.cliente.xtensaBasica == true) {
        this.addFacturaBasica(this.userlog.cliente.id, data.createContratista.contratista.id, this.datosContratista.value.numeroCentros)

      }else{
        this.addFacturaAmpliada(this.userlog.cliente.id, data.createContratista.contratista.id, this.datosContratista.value.numeroCentros)
      }
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  getContratistasCif(element:any){
    
    const options = {
      text:'Ya hay un contratista registrado en la aplicación con ese CIF, si lo desea puede enviar un mail invitandolo a pagar los centros productores seleccionados.',
      cancelText: 'Cancelar',
      confirmText: 'Enviar'
    };
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistasCif()
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
    
        const contratistasArray = data.contratistas.filter((contratista:any)=>          
          contratista.cif == element.cif)
  
          if (contratistasArray.length > 0) {
            
            this.confirmacionService.open(options);
   
              this.confirmacionService.confirmed().subscribe(confirmed => {
            if (confirmed) {
              if (this.userlog.cliente.xtensaBasica == true) {
                this.addFacturaBasica(this.userlog.cliente.id, contratistasArray[0].id, this.datosContratista.value.numeroCentros)
              }else{
                this.addFacturaAmpliada(this.userlog.cliente.id, contratistasArray[0].id, this.datosContratista.value.numeroCentros)
              }
              let templateContratista = `
              <!DOCTYPE html>
              <html>
              <head>
              <title></title>
              </head>

              <body>
              <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/ampliacion_d5bfa07702.png' style="width:500px; height:340px; display:block;
              margin:auto;">
              <div style="width:500px; margin:auto">
              <p>Estimado ${contratistasArray[0].contactoResponsable.mail}</p>
              <p>Su cliente ${this.nombreComercial} le solicita el registro en Xtensa de ${this.datosContratista.value.numeroCentros} nuevos centros Productores.</p>
              <p>Por favor a continuación, inicie sesión para el pago de las correspondientes licencias. </p>
              <a href="www.xtensa.es"><img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/AV_96b6ea682a.png' style="width:100px; height:63px; display:block;
              margin:auto;"></a>
              </div>
              <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
              margin:70px auto;">
              </body>
              </html>`;

                this.emailService.send(
                  contratistasArray[0].contactoResponsable.mail,
                  'Invitación Xtensa',
                    templateContratista
                );

            }
            });
          
           


         } else {
           this.addContratista();
         }
                
        
      })
  }

  addUsuarioContratista(mail: any, password: any, contratista: any) {
    this.apollo
      .mutate<any>({
        mutation: this.usuarioService.addUser(),
        variables: {
          input: {
            data: {
              email: mail,
              username: mail,
              password: password,
              rol: 'admin',
              contratista: contratista,
              confirmed: true,
            },
          },
        },
      })
      .subscribe(
        ({ data, errors }) => {
          console.log('ok');
        },
        (error: any) => {
          console.log('Error al lanzar la query', error);
        }
      );
  }
  

  addFacturaBasica(idCliente: any, idContratista: any, numero: any) {
    const baseImponible = this.precioBasica * numero
    const importeIva = (baseImponible * this.iva) / 100
    const precioTotal = baseImponible + importeIva
    console.log(baseImponible, importeIva, precioTotal);
    
    this.apollo
      .mutate({
        mutation: this.facturaService.addFactura(),
        variables: {
          input: {
            data: {
              cliente: idCliente,
              contratista: idContratista,
              numeroLicencias: numero,
              concepto: "LICENCIA XTENSA ANUAL AMPLIADA",
              estado: "invitacion",
              precioUnitario: this.precioBasica,
              iva: this.iva,
              baseImponible: baseImponible,
              precioTotal: precioTotal,
            },
          },
        },
      })
      .subscribe(
        ({ data, errors }) => {
            console.log('OK', data);
        },
        (error) => {
          console.log('Error al lanzar la query', error);
        }
      );
  }

  addFacturaAmpliada(idCliente: any, idContratista: any, numero: any) {
    const baseImponible = this.precioAmpliada * numero
    const importeIva = (baseImponible * this.iva) / 100
    const precioTotal = baseImponible + importeIva
    console.log(baseImponible, importeIva, precioTotal);
    
    this.apollo
      .mutate({
        mutation: this.facturaService.addFactura(),
        variables: {
          input: {
            data: {
              cliente: idCliente,
              contratista: idContratista,
              numeroLicencias: numero,
              concepto: "LICENCIA XTENSA ANUAL AMPLIADA",
              estado: "invitacion",
              precioUnitario: this.precioAmpliada,
              iva: this.iva,
              baseImponible: baseImponible,
              precioTotal: precioTotal,
            },
          },
        },
      })
      .subscribe(
        ({ data, errors }) => {
            console.log('OK', data);
        },
        (error) => {
          console.log('Error al lanzar la query', error);
        }
      );
  }

  generatePassword() {
    let length = 8,
      charset =
        'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
      retVal = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }
}
